module.exports = __webpack_public_path__ + "static/media/yt-apple-store.9c586acb.mov";